import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Divider } from 'antd'
import Title from 'antd/es/typography/Title'
import AboutPage from '../../component/showcase/AboutPage'
import { getArtistStory, patchArtistStory } from '../../api/artistStories'
import { convertToRaw, EditorState } from 'draft-js'
import { convertFromHTML } from 'draft-convert'
import HttpError from '../../component/base/HttpError'
import { getArtistBio, patchArtistBio } from '../../api/artistBio'
import { getArtistProfile } from '../../api/artistProfiles'
import BrowserBorder from '../../component/showcase/BrowserBorder'
import SaveChangesButton from '../../component/showcase/SaveChangesButton'
import { UpdateSuccess } from '../../component/base/HttpMessage'
import { getArtist, getArtistProfilePublic, patchArtistProfile } from '../../api/artists'
import ShowcasePreviewLayout from '../../component/showcase/ShowcasePreviewLayout'

@connect((state) => ({
  //decorator, gives component access to the state
  siderWidth: state.style.siderWidth,
  id: state.user.info.id,
  userId: state.user.info.userId,
  artistId: state.user.info.artistId,
  email: state.user.info.email,
  artistName: state.user.info.artistName
}))
class About extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      profile: {},
      bio: {},
      bioRaw: null,
      story: {},
      storyRaw: null,
      profileChanged: false,
      bioChanged: false,
      storyChanged: false
    }
    this.onProfilePhotoSubmit = this.onProfilePhotoSubmit.bind(this)
    this.onBioSubmit = this.onBioSubmit.bind(this)
    this.onStorySubmit = this.onStorySubmit.bind(this)
    this.onArtVideoSubmit = this.onArtVideoSubmit.bind(this)
    this.onSaveChanges = this.onSaveChanges.bind(this)
  }

  getRawEditorData(data) {
    if (!data) return null
    const editorState = EditorState.createWithContent(convertFromHTML(data))
    const body = convertToRaw(editorState.getCurrentContent())
    return JSON.stringify(body)
  }

  componentDidMount() {
    this.IS_MOUNT = true
    getArtist(this.props.userId)
      .then((res) => {
        if (!this.IS_MOUNT) return
      })
      .catch((error) => {
        if (!this.IS_MOUNT) return
        HttpError(error)
      })

    getArtistProfile(this.props.artistId)
      .then((responseProfile) => {
        if (!this.IS_MOUNT) return
        this.setState({
          profile: {
            avatar: responseProfile.data.avatar,
            profile_image: responseProfile.data.profile_image,
            video: responseProfile.data.video,
            job_title: responseProfile.data.job_title,
            city: responseProfile.data.city,
            country: responseProfile.data.country
          }
        })
      })
      .catch((error) => {
        if (!this.IS_MOUNT) return
        HttpError(error)
      })

    getArtistStory(this.props.artistId)
      .then((response) => {
        if (!this.IS_MOUNT) return
        if (response.data?.body) {
          this.setState({
            story: {
              title: response.data.title,
              body: response.data.body
            },
            storyRaw: this.getRawEditorData(response.data.body)
          })
        }
      })
      .catch((error) => {
        if (!this.IS_MOUNT) return
        HttpError(error)
      })

    getArtistBio(this.props.artistId)
      .then((response) => {
        if (!this.IS_MOUNT) return
        if (response.data.body) {
          this.setState({
            bio: {
              body: response.data.body
            },
            bioRaw: this.getRawEditorData(response.data.body)
          })
        }
      })
      .catch((error) => {
        if (!this.IS_MOUNT) return
        HttpError(error)
      })

    getArtistProfilePublic(this.props.artistId)
      .then((response) => {
        this.setState({
          profileDetail: response.data
        })
      })
      .catch((error) => {
        if (!this.IS_MOUNT) return
        HttpError(error)
      })
  }

  componentWillUnmount() {
    this.IS_MOUNT = false
  }

  onProfilePhotoSubmit(url) {
    if (url !== this.state.profile.avatar) {
      this.setState({
        profileChanged: true,
        profile: {
          avatar: url,
          image: this.state.profile.image,
          video: this.state.profile.video
        }
      })
    }
  }

  onBioSubmit(data) {
    if (this.state.bio.body !== data) {
      this.setState({
        bioChanged: true,
        bio: {
          body: data
        },
        bioRaw: this.getRawEditorData(data)
      })
    }
  }

  onStorySubmit(title, data) {
    if (this.state.story.title !== title || this.state.story.body !== data) {
      this.setState({
        storyChanged: true,
        story: {
          title: title,
          body: data
        },
        storyRaw: this.getRawEditorData(data)
      })
    }
  }

  onArtVideoSubmit(url) {
    if (url !== this.state.profile.video) {
      this.setState({
        profileChanged: true,
        profile: {
          avatar: this.state.profile.avatar,
          video: url,
          image: this.state.profile.image
        }
      })
    }
  }

  onSaveChanges() {
    if (this.state.profileChanged) {
      patchArtistProfile(this.props.artistId, {
        avatar: this.state.profile.avatar,
        video: this.state.profile.video
      })
        .then(() => {
          if (!this.IS_MOUNT) return
          UpdateSuccess('Profile photo updated successfully')
          this.setState({
            profileChanged: false
          })
        })
        .catch((error) => {
          if (!this.IS_MOUNT) return
          HttpError(error)
        })
    }
    if (this.state.bioChanged) {
      patchArtistBio(this.props.artistId, {
        body: this.state.bio.body,
        artist: this.props.artistId
      })
        .then(() => {
          if (!this.IS_MOUNT) return
          UpdateSuccess('Bio updated successfully')
          this.setState({
            bioChanged: false
          })
        })
        .catch((error) => {
          if (!this.IS_MOUNT) return
          HttpError(error)
        })
    }
    if (this.state.storyChanged) {
      patchArtistStory(this.props.artistId, {
        title: this.state.story.title,
        body: this.state.story.body,
        artist: this.props.artistId
      })
        .then(() => {
          if (!this.IS_MOUNT) return
          UpdateSuccess('Statement updated successfully')
          this.setState({
            storyChanged: false
          })
        })
        .catch((error) => {
          if (!this.IS_MOUNT) return
          HttpError(error)
        })
    }
  }

  render() {
    return (
      <ShowcasePreviewLayout {...this.props}>
        <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between' }}>
          <div>
            <Title style={{ marginBottom: 0 }}>About page</Title>
          </div>
        </div>
        <div></div>
        <Divider />
        <BrowserBorder {...this.props}>
          <AboutPage
            {...this.props}
            profile={this.state.profile}
            profileDetail={this.state.profileDetail}
            bio={this.state.bio}
            story={this.state.story}
            bioContent={this.state.bioRaw}
            storyContent={this.state.storyRaw}
            onProfilePhotoSubmit={this.onProfilePhotoSubmit}
            onBioSubmit={this.onBioSubmit}
            onArtVideoSubmit={this.onArtVideoSubmit}
            onStorySubmit={this.onStorySubmit}
          />
        </BrowserBorder>
        {(this.state.profileChanged || this.state.bioChanged || this.state.storyChanged) && (
          <SaveChangesButton {...this.props} onSave={this.onSaveChanges} />
        )}
      </ShowcasePreviewLayout>
    )
  }
}

export default withRouter(About)
